<template>
    <div
        v-if="$validateText(data)" 
        v-tooltip="{
            content: data,
            trigger: 'manual',
            show: show
        }" 
        class="tooltip-wrapper"
        @mouseover="show = true"
        @click="show = true"
        @mouseleave="show = false"    
    >
        <slot>
            <i class="fa-solid fa-info-circle tooltip-icon" />  
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            show: false
        };
    }
};
</script>

<style lang="scss" scoped>
    .tooltip-wrapper {
        display: inline-block;
    }
</style>